import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';

const ProductCtaSection = () => {
  const { t } = useTranslation();
  const { language } = useLanguage();

  return (
    <section className="section section-light" style={{ 
      position: 'relative',
      overflow: 'hidden',
      padding: '6rem 0'
    }}>
      {/* Decorative elements */}
      <div style={{
        position: 'absolute',
        top: '0',
        right: '0',
        width: '300px',
        height: '300px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255, 107, 0, 0.03) 0%, rgba(255, 107, 0, 0) 70%)',
        zIndex: 1
      }}></div>
      
      <div style={{
        position: 'absolute',
        bottom: '10%',
        left: '5%',
        width: '200px',
        height: '200px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255, 107, 0, 0.03) 0%, rgba(255, 107, 0, 0) 70%)',
        zIndex: 1
      }}></div>
      
      <div className="container" style={{ position: 'relative', zIndex: 2, maxWidth: '1200px', margin: '0 auto', padding: '0 1.5rem' }}>
        <div className="cta-card fade-in" style={{
          background: 'linear-gradient(135deg, #2D3748 0%, #1A202C 100%)',
          borderRadius: '1.5rem',
          padding: '0',
          color: 'white',
          position: 'relative',
          overflow: 'hidden',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
          display: 'flex',
          flexDirection: 'column'
        }}>
          {/* Top decorative pattern */}
          <div style={{
            position: 'absolute',
            top: '0',
            left: '0',
            right: '0',
            height: '8px',
            background: 'linear-gradient(90deg, var(--assco-orange) 0%, #E53E3E 100%)',
            zIndex: 3
          }}></div>
          
          {/* Decorative shapes */}
          <div style={{
            position: 'absolute',
            top: '-80px',
            right: '-80px',
            width: '200px',
            height: '200px',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(255, 107, 0, 0.3) 0%, rgba(255, 107, 0, 0) 70%)',
            zIndex: 1
          }}></div>
          
          <div style={{
            position: 'absolute',
            bottom: '-50px',
            left: '10%',
            width: '150px',
            height: '150px',
            borderRadius: '30% 70% 70% 30% / 30% 30% 70% 70%',
            background: 'radial-gradient(circle, rgba(255, 107, 0, 0.2) 0%, rgba(255, 107, 0, 0) 70%)',
            transform: 'rotate(45deg)',
            zIndex: 1
          }}></div>
          
          <div style={{
            position: 'absolute',
            top: '30%',
            right: '15%',
            width: '40px',
            height: '40px',
            borderRadius: '30% 70% 70% 30% / 30% 30% 70% 70%',
            backgroundColor: 'rgba(255, 107, 0, 0.2)',
            transform: 'rotate(45deg)',
            animation: 'float 6s ease-in-out infinite',
            zIndex: 1
          }}></div>
          
          <div style={{
            position: 'absolute',
            bottom: '20%',
            left: '20%',
            width: '25px',
            height: '25px',
            borderRadius: '50%',
            backgroundColor: 'rgba(255, 107, 0, 0.2)',
            animation: 'float 5s ease-in-out infinite',
            animationDelay: '1s',
            zIndex: 1
          }}></div>
          
          <div style={{
            position: 'absolute',
            top: '15%',
            left: '10%',
            width: '15px',
            height: '15px',
            borderRadius: '50%',
            backgroundColor: 'rgba(255, 107, 0, 0.3)',
            animation: 'float 4s ease-in-out infinite',
            animationDelay: '2s',
            zIndex: 1
          }}></div>
          
          {/* Pattern background */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            opacity: 0.03,
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23FFFFFF' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            zIndex: 1
          }}></div>
          
          <div style={{ padding: '4rem', position: 'relative', zIndex: 2 }}>
            <span style={{
              display: 'inline-block',
              padding: '0.4rem 1rem',
              backgroundColor: 'rgba(255, 107, 0, 0.2)',
              color: 'var(--assco-orange)',
              borderRadius: '20px',
              fontWeight: '600',
              fontSize: '0.75rem',
              marginBottom: '1rem',
              textTransform: 'uppercase',
              letterSpacing: '0.05em'
            }}>
              {language === 'fr' ? 'SOLUTIONS PERSONNALISÉES' : 
              language === 'ar' ? 'حلول مخصصة' : 
              'CUSTOM SOLUTIONS'}
            </span>
            
            <div className="grid" style={{ 
              display: 'grid',
              gridTemplateColumns: 'repeat(12, 1fr)', 
              gap: '3rem',
              alignItems: 'center'
            }}>
              <div className="col-span-7 md-col-span-12">
                <h2 style={{ 
                  fontSize: '2.75rem',
                  lineHeight: '1.2',
                  marginBottom: '1.5rem',
                  color: 'white',
                  fontWeight: '700'
                }}>
                  {language === 'fr' 
                    ? 'Besoin d\'une solution d\'instrumentation spécifique ?' 
                    : language === 'ar'
                    ? 'هل تحتاج إلى حل قياس محدد؟'
                    : 'Need a specific instrumentation solution?'}
                </h2>
                
                <p style={{ 
                  fontSize: '1.25rem',
                  marginBottom: '2.5rem',
                  color: 'rgba(255, 255, 255, 0.9)',
                  lineHeight: '1.7',
                  maxWidth: '700px'
                }}>
                  {language === 'fr' 
                    ? 'Contactez notre équipe d\'experts pour discuter de vos besoins spécifiques en matière d\'instrumentation Pétrole, Gaz et Industrie. Nous vous aiderons à trouver la solution idéale pour vos applications.' 
                    : language === 'ar'
                    ? 'اتصل بفريق الخبراء لدينا لمناقشة احتياجاتك المحددة في مجال أجهزة القياس البتروكيماوية. سنساعدك في العثور على الحل المثالي لتطبيقاتك.'
                    : 'Contact our team of experts to discuss your specific petrochemical instrumentation needs. We\'ll help you find the ideal solution for your applications.'}
                </p>
                
                <div style={{
                  display: 'flex',
                  gap: '1rem',
                  flexWrap: 'wrap'
                }}>
                  <Link 
                    to="/contact" 
                    className="btn btn-primary"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      backgroundColor: 'var(--assco-orange)',
                      color: 'white',
                      padding: '1rem 2.5rem',
                      borderRadius: '50px',
                      fontWeight: '600',
                      fontSize: '1rem',
                      textDecoration: 'none',
                      transition: 'all 0.3s ease',
                      boxShadow: '0 10px 15px -3px rgba(255, 107, 0, 0.3), 0 4px 6px -4px rgba(255, 107, 0, 0.3)',
                      position: 'relative',
                      overflow: 'hidden'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.backgroundColor = '#e25a00';
                      e.currentTarget.style.transform = 'translateY(-3px)';
                      e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(255, 107, 0, 0.3), 0 8px 10px -6px rgba(255, 107, 0, 0.3)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.backgroundColor = 'var(--assco-orange)';
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(255, 107, 0, 0.3), 0 4px 6px -4px rgba(255, 107, 0, 0.3)';
                    }}
                    onClick={(e) => {
                      const ripple = document.createElement('span');
                      ripple.classList.add('ripple');
                      e.currentTarget.appendChild(ripple);
                      
                      const rect = e.currentTarget.getBoundingClientRect();
                      const x = e.clientX - rect.left;
                      const y = e.clientY - rect.top;
                      
                      ripple.style.left = `${x}px`;
                      ripple.style.top = `${y}px`;
                      
                      setTimeout(() => {
                        ripple.remove();
                      }, 600);
                    }}
                  >
                    {language === 'fr' ? 'Demander un devis' : 
                    language === 'ar' ? 'طلب عرض أسعار' : 
                    'Request a quote'}
                    <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '18px', height: '18px' }} viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </Link>
                  
                  <Link 
                    to="/services" 
                    className="btn btn-outline"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      backgroundColor: 'transparent',
                      color: 'white',
                      padding: '1rem 2.5rem',
                      borderRadius: '50px',
                      border: '2px solid rgba(255, 255, 255, 0.7)',
                      fontWeight: '600',
                      fontSize: '1rem',
                      textDecoration: 'none',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                      e.currentTarget.style.transform = 'translateY(-3px)';
                      e.currentTarget.style.borderColor = 'white';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.7)';
                    }}
                  >
                    {language === 'fr' ? 'Voir nos services' : 
                    language === 'ar' ? 'عرض خدماتنا' : 
                    'View our services'}
                  </Link>
                </div>
              </div>
              
              <div className="col-span-5 md-col-span-12 md-hidden" style={{ position: 'relative' }}>
                {/* Product graphic - enhanced 3D version */}
                <div style={{
                  position: 'relative',
                  width: '100%',
                  height: '350px',
                  perspective: '1000px'
                }}>
                  <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%) rotate3d(1, 1, 0, 30deg)',
                    width: '220px',
                    height: '220px',
                    borderRadius: '24px',
                    backgroundColor: 'rgba(255, 255, 255, 0.03)',
                    backdropFilter: 'blur(20px)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    boxShadow: '0 25px 50px rgba(0, 0, 0, 0.2), 0 0 40px rgba(255, 107, 0, 0.1) inset',
                    overflow: 'hidden',
                    animation: 'float 6s ease-in-out infinite',
                  }}>
                    {/* Inner content */}
                    <div style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      width: '120px',
                      height: '120px',
                      borderRadius: '30% 70% 70% 30% / 30% 30% 70% 70%',
                      backgroundColor: 'var(--assco-orange)',
                      opacity: '0.8',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 0 60px rgba(255, 107, 0, 0.6)',
                      animation: 'pulse 5s infinite',
                    }}>
                      <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '60px', height: '60px', color: 'white' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
                      </svg>
                    </div>
                    
                    {/* Decorative dots */}
                    <div style={{
                      position: 'absolute',
                      top: '20px',
                      left: '20px',
                      width: '10px',
                      height: '10px',
                      borderRadius: '50%',
                      backgroundColor: 'rgba(255, 255, 255, 0.5)',
                    }}></div>
                    
                    <div style={{
                      position: 'absolute',
                      top: '20px',
                      right: '20px',
                      width: '10px',
                      height: '10px',
                      borderRadius: '50%',
                      backgroundColor: 'rgba(255, 255, 255, 0.5)',
                    }}></div>
                    
                    <div style={{
                      position: 'absolute',
                      bottom: '20px',
                      left: '20px',
                      width: '10px',
                      height: '10px',
                      borderRadius: '50%',
                      backgroundColor: 'rgba(255, 255, 255, 0.5)',
                    }}></div>
                    
                    <div style={{
                      position: 'absolute',
                      bottom: '20px',
                      right: '20px',
                      width: '10px',
                      height: '10px',
                      borderRadius: '50%',
                      backgroundColor: 'rgba(255, 255, 255, 0.5)',
                    }}></div>
                  </div>
                  
                  {/* Background decorative circles */}
                  <div style={{
                    position: 'absolute',
                    top: '30%',
                    left: '20%',
                    width: '140px',
                    height: '140px',
                    borderRadius: '50%',
                    border: '2px solid rgba(255, 107, 0, 0.15)',
                    animation: 'float 7s ease-in-out infinite',
                    animationDelay: '1s'
                  }}></div>
                  
                  <div style={{
                    position: 'absolute',
                    bottom: '20%',
                    right: '25%',
                    width: '80px',
                    height: '80px',
                    borderRadius: '50%',
                    border: '2px solid rgba(255, 107, 0, 0.1)',
                    animation: 'float 5s ease-in-out infinite',
                    animationDelay: '0.5s'
                  }}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <style jsx>{`
        @keyframes pulse {
          0% {
            transform: scale(1);
            opacity: 0.8;
          }
          50% {
            transform: scale(1.05);
            opacity: 1;
          }
          100% {
            transform: scale(1);
            opacity: 0.8;
          }
        }
        
        @keyframes float {
          0% {
            transform: translateY(0px) rotate3d(1, 1, 0, 30deg);
          }
          50% {
            transform: translateY(-10px) rotate3d(1, 1, 0, 30deg);
          }
          100% {
            transform: translateY(0px) rotate3d(1, 1, 0, 30deg);
          }
        }
        
        .ripple {
          position: absolute;
          border-radius: 50%;
          background-color: rgba(255, 255, 255, 0.3);
          transform: scale(0);
          animation: ripple 0.6s linear;
        }
        
        @keyframes ripple {
          to {
            transform: scale(4);
            opacity: 0;
          }
        }
        
        @media (max-width: 768px) {
          .md-hidden {
            display: none;
          }
          
          .md-col-span-12 {
            grid-column: span 12;
          }
        }
      `}</style>
    </section>
  );
};

export default ProductCtaSection;